import { getAccessToken, getGlobals } from '@/lib/globals';

/** Adds a hidden form and submits it for internal redirect */
export const goToMemberXO = (paramsString: string): void => {
  const {
    noCookie: { nsid, _csrf },
  } = getGlobals();

  if (!_csrf) {
    throw new Error('No csrf was found in globals');
  }
  if (!nsid) {
    throw new Error('No nsid was found in globals');
  }

  const form = document.createElement('form');

  form.method = 'POST';
  form.action = `/checkoutweb/goToMemberXO${paramsString}`;
  form.style.display = 'none;';

  const tokenInput = document.createElement('input');
  tokenInput.name = 'accessToken';
  tokenInput.value = getAccessToken().value || '';
  tokenInput.type = 'hidden';

  const csrfInput = document.createElement('input');
  csrfInput.name = '_csrf';
  csrfInput.value = _csrf;
  csrfInput.type = 'hidden';

  const nsidInput = document.createElement('input');
  nsidInput.name = 'nsid';
  nsidInput.value = nsid;
  nsidInput.type = 'hidden';

  form.appendChild(tokenInput);
  form.appendChild(csrfInput);
  form.appendChild(nsidInput);

  globalThis.document.body.appendChild(form);
  form.submit();
};
